export const numberOfSeatsSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path
      stroke="#444"
      d="M4.638 2.895A1.5 1.5 0 0 1 6.135 1.5h3.763a1.5 1.5 0 0 1 1.497 1.4l.57 8.6H4.037l.602-8.605ZM12.5 12a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 12v-.5h9v.5Z"
    />
    <path
      fill="#444"
      d="M5.5 15a.5.5 0 0 0 1 0h-1Zm0-2v2h1v-2h-1ZM9.5 15a.5.5 0 0 0 1 0h-1Zm0-2v2h1v-2h-1Z"
    />
    <path stroke="#444" d="M2.5 9.5h1M12.5 9.5h1M3.5 12V9M12.5 12V9" />
  </svg>
);

export const drinksSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path
      stroke="#444"
      d="M11.666 5.667h.667a2.667 2.667 0 0 1 0 5.333h-.667"
    />
    <path
      stroke="#444"
      d="M1 5.667h10.667v6A2.667 2.667 0 0 1 9 14.333H3.667A2.667 2.667 0 0 1 1 11.667v-6ZM3.667 1v2M6.333 1v2M9 1v2"
    />
  </svg>
);

export const parkingSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path
      fill="#444"
      d="M5.544 12h1.452V9.264h.972c2.028 0 3.144-1.104 3.144-2.712S10.248 4.08 8.196 4.08H5.544V12Zm1.452-3.876V5.22h.912c1.332 0 1.704.42 1.704 1.464 0 .828-.492 1.44-1.668 1.44h-.948Z"
    />
    <rect width="15" height="15" x=".5" y=".5" stroke="#444" rx="1.5" />
  </svg>
);

export const elevatorSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path stroke="#444" d="M8 14V2M2 8l6-6 6 6" />
  </svg>
);

export const wheelchairSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path stroke="#444" d="M10.67 12.6a4.7 4.7 0 1 1-6.39-6.35" />
    <path
      fill="#444"
      stroke="#444"
      d="M6.66 1.7a.77.77 0 1 1-1.54 0 .77.77 0 0 1 1.54 0Z"
    />
    <path
      stroke="#444"
      d="m5.85 3.79.11 5.77h4.34l2.51 3.04h1.35M5.93 5.63h4.12"
    />
  </svg>
);

export const cloakroomSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" fill="none">
    <path
      stroke="#444"
      d="M5 2.667a2 2 0 1 1 2 2V6m0 0 5.75 3.659a.547.547 0 0 1-.294 1.008H1.544a.546.546 0 0 1-.294-1.008L7 6Z"
    />
  </svg>
);

export const airConditioningSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <g stroke="#444">
      <path d="M6.667 2.667 8 3.333l1.333-.666M8 1.333v4.334l2 1.146M11.952 4.179l.09 1.488 1.244.821m.488-1.821L10.02 6.833l.007 2.306M13.285 9.512l-1.244.821-.09 1.488m1.822-.488-3.752-2.166-1.994 1.159M9.334 13.333 8 12.667l-1.333.666M8 14.667v-4.334L6 9.187M4.048 11.821l-.09-1.488-1.244-.821m-.488 1.821L5.98 9.167 5.972 6.86M2.715 6.488l1.244-.821.09-1.488m-1.822.488 3.752 2.166 1.994-1.158" />
    </g>
  </svg>
);

export const wifiSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path
      stroke="#444"
      d="M4.03 8.445a6.238 6.238 0 0 1 7.986 0M2 6.267a9.074 9.074 0 0 1 12 0M6.032 10.629a3.403 3.403 0 0 1 3.942 0M8 12.505h.006"
    />
  </svg>
);

export const barSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path
      stroke="#444"
      d="M2.5 4.907v8.263a1.25 1.25 0 0 0 1.237 1.25l6.5.067a1.25 1.25 0 0 0 1.263-1.25v-8.33"
    />
    <path
      stroke="#444"
      d="M11.5 6.5H13a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1.5v-5ZM4.5 11.5V8M7 11.5V8m2.5 3.5V8"
    />
    <path
      fill="#444"
      d="M7.514 2.092c.082-.093.252-.208.514-.3.255-.09.564-.145.889-.145.226 0 .534.127.794.377.256.247.41.559.41.864 0 .053-.003.105-.01.156l-.04.309.271.153c.149.084.328.279.474.553.143.271.221.557.221.774 0 .058-.002.113-.005.167h.927c.003-.055.004-.111.004-.167 0-.405-.134-.84-.33-1.208a2.55 2.55 0 0 0-.586-.75c-.004-.61-.307-1.145-.694-1.518-.385-.37-.912-.636-1.436-.636-.426 0-.839.072-1.195.197a2.572 2.572 0 0 0-.581.285 2.036 2.036 0 0 0-.169-.077c-.2-.08-.43-.14-.666-.175-.461-.07-1.015-.061-1.474.118-.398.155-.789.379-1.08.727-.221.264-.37.582-.432.955a1.49 1.49 0 0 0-.927.65c-.268.41-.356.93-.356 1.432 0 .056.002.112.007.167h.93a1.214 1.214 0 0 1-.011-.167c0-.417.077-.73.204-.924.108-.165.271-.28.583-.28h.463v-.462c0-.362.102-.601.25-.777.154-.185.389-.335.705-.459.256-.1.632-.12 1-.065.177.027.336.07.46.12a.93.93 0 0 1 .18.096l.012.01.347.394.347-.394Z"
    />
    <path stroke="#444" d="M2.5 5.5h9" />
  </svg>
);

export const waterDropSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path stroke="#444" d="M4.533 7.333a4 4 0 1 0 6.93 0L8 2 4.533 7.333Z" />
  </svg>
);

export const washroomSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path
      fill="#444545"
      d="M5.309 4.333c-.045 0-.09 0-.135-.006a1.484 1.484 0 0 1 .266-2.954 1.481 1.481 0 0 1-.131 2.957v.003ZM5.306 2.17a.68.68 0 0 0-.522 1.117.678.678 0 0 0 .96.086.675.675 0 0 0 .086-.96.678.678 0 0 0-.46-.243h-.064ZM6.573 14.122l-.8-.036.192-4.192a.543.543 0 0 1 .544-.518h.771l-.509-3.12a.98.98 0 0 0-.97-.826h-.995a.977.977 0 0 0-.97.826l-.508 3.12H4.1c.292 0 .528.227.544.518l.192 4.192-.8.036-.179-3.95h-.829a.545.545 0 0 1-.534-.63l.557-3.417c.14-.867.88-1.495 1.76-1.495h.995c.877 0 1.62.63 1.76 1.495l.557 3.417a.545.545 0 0 1-.535.63h-.829l-.179 3.95h-.006ZM11.239 4.333c-.426 0-.845-.183-1.14-.531a1.484 1.484 0 0 1 .19-2.087 1.482 1.482 0 1 1 .95 2.618Zm0-2.163a.68.68 0 1 0 .438 1.203.684.684 0 0 0 .086-.96.685.685 0 0 0-.524-.243ZM12.611 14.112l-.8-.02.1-4.188a.547.547 0 0 1 .543-.531h.333V5.962a.535.535 0 0 0-.534-.535h-2.026a.535.535 0 0 0-.534.535v3.41h.332c.298 0 .535.234.544.532l.1 4.189-.8.019-.093-3.936h-.34a.544.544 0 0 1-.543-.544v-3.67c0-.736.598-1.335 1.334-1.335h2.026c.736 0 1.334.599 1.334 1.335v3.67c0 .3-.243.544-.544.544h-.34l-.092 3.936Z"
    />
  </svg>
);

export const binocularSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path
      stroke="#444"
      d="M10 7.5H5.75M9.5 9.5H6m-1-3 .454-1.363A.2.2 0 0 1 5.644 5h4.712a.2.2 0 0 1 .19.137L11 6.5"
    />
    <path
      stroke="#444"
      d="M15 8.679a2.679 2.679 0 1 1-5.357 0 2.679 2.679 0 0 1 5.357 0ZM6.292 8.679c0 1.479-1.134 2.678-2.613 2.678a2.679 2.679 0 1 1 0-5.357C5.158 6 6.292 7.2 6.292 8.68Z"
    />
    <path
      stroke="#444"
      d="M4 10a1.5 1.5 0 0 1-1.5-1.5M12.5 10A1.5 1.5 0 0 1 11 8.5"
    />
  </svg>
);

export const accessibleToiletsSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path
      fill="#444545"
      d="M5.856 4.653c-.426 0-.845-.183-1.14-.531a1.481 1.481 0 1 1 1.136.531h.004Zm0-2.163a.68.68 0 0 0-.522 1.116c.24.288.672.327.96.087A.684.684 0 0 0 5.92 2.49h-.064ZM5.86 14a3.714 3.714 0 0 1-2.384-6.57c.336-.278.71-.496 1.116-.643a.4.4 0 0 1 .272.752 2.92 2.92 0 0 0-1.248 4.614 2.92 2.92 0 0 0 4.82-.505.4.4 0 0 1 .707.374 3.683 3.683 0 0 1-.906 1.117A3.7 3.7 0 0 1 5.86 14Z"
    />
    <path
      fill="#444545"
      d="M10.057 12.346 8.464 9.28a.112.112 0 0 0-.096-.058H6.2a.75.75 0 0 1-.748-.748V5.446a.4.4 0 0 1 .8 0V8.42h2.112c.339 0 .65.189.806.49l1.254 2.41.804-.34a.4.4 0 0 1 .524.215.4.4 0 0 1-.214.524l-1.485.624.003.004Z"
    />
    <path
      fill="#444545"
      d="M8.211 7.008H5.856a.4.4 0 0 1 0-.8h2.355a.4.4 0 0 1 0 .8ZM8.253 2.34h.531l.426 1.836.499-1.837h.483l.496 1.843.429-1.843h.515l-.717 2.547h-.467l-.505-1.862-.512 1.862h-.474l-.7-2.547h-.004ZM11.648 3.613c0-.794.486-1.325 1.206-1.325.599 0 1.021.31 1.133.944h-.502c-.08-.362-.304-.502-.634-.502-.432 0-.694.326-.694.864v.038c0 .54.256.864.688.864.348 0 .579-.15.65-.54h.502c-.096.668-.541.982-1.162.982-.7 0-1.18-.535-1.18-1.325h-.007Z"
    />
  </svg>
);

export const hearingSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <g stroke="#444">
      <path d="M4 6.667a4.667 4.667 0 1 1 8.667 2.4c-.38.505-.828.954-1.334 1.333a5.335 5.335 0 0 0-1.333 2 3 3 0 0 1-4.533.933" />
      <path d="M6.667 6.667A2 2 0 1 1 10 8.133" />
    </g>
  </svg>
);

export const boosterCushionSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path
      fill="#444545"
      d="M12.086 9.955H7.35a2 2 0 0 1-1.996-1.997v-1.93h8.73v1.93a2 2 0 0 1-1.998 1.997ZM6.154 6.83v1.13A1.2 1.2 0 0 0 7.35 9.154h4.736a1.2 1.2 0 0 0 1.197-1.197v-1.13h-7.13Z"
    />
    <path
      fill="#444545"
      d="M13.53 6.608s-.39-.378-.624-.774c-.215-.362-.199-.839-.141-1.197-.269-.074-.57-.195-.803-.39-.256-.215-.41-.545-.503-.849-.285.064-.659.1-1.024-.022a2.419 2.419 0 0 1-.317-.128v3.178h-.8V2.269l.266-.128a.424.424 0 0 1 .467.096c.077.077.288.269.634.38.294.097.659-.006.8-.054a.524.524 0 0 1 .685.39c.067.317.182.58.304.682.14.119.406.224.71.282a.53.53 0 0 1 .41.643c-.093.374-.093.717 0 .87.179.301.486.602.49.605l-.558.576.004-.003Z"
    />
    <path
      fill="#444545"
      d="M12.951 4.101 9.518 6.083l.4.693 3.433-1.982-.4-.693Z"
    />
    <path
      fill="#444545"
      d="M11.356 2.795 9.374 6.23l.693.4 1.982-3.434-.693-.4ZM5.395 6.605l-.643-1.309H3.664v-.8h1.584l.867 1.757-.72.352Z"
    />
    <path
      fill="#444545"
      d="M3.616 5.92H2.48a.807.807 0 0 1-.806-.806v-.432c0-.445.361-.807.806-.807h1.136c.445 0 .807.362.807.807v.432a.807.807 0 0 1-.807.806ZM2.48 4.675l-.006.439 1.145.006s.007 0 .007-.006v-.432L2.48 4.675ZM7.078 13.933c-.848 0-1.539-.691-1.539-1.54 0-.847.691-1.539 1.54-1.539.847 0 1.538.692 1.538 1.54 0 .848-.69 1.539-1.539 1.539Zm0-2.278a.742.742 0 0 0-.739.739c0 .406.333.739.74.739.406 0 .738-.333.738-.74a.742.742 0 0 0-.739-.739ZM12.544 13.933c-.848 0-1.54-.691-1.54-1.54 0-.847.692-1.539 1.54-1.539.848 0 1.54.692 1.54 1.54 0 .848-.692 1.539-1.54 1.539Zm0-2.278a.742.742 0 0 0-.74.739c0 .406.334.739.74.739.406 0 .74-.333.74-.74a.742.742 0 0 0-.74-.739Z"
    />
    <path
      fill="#444545"
      d="M11.405 11.994H8.216v.8h3.188v-.8ZM7.857 9.514l-.788 1.62.72.35.788-1.62-.72-.35ZM11.58 9.517l-.72.35.789 1.62.72-.35-.789-1.62Z"
    />
  </svg>
);

export const shopSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path
      stroke="#444"
      d="M2.956 4.14a.687.687 0 0 1 .686-.64H12.67c.361 0 .66.28.686.64l.593 8.625a.687.687 0 0 1-.686.735H3.049a.687.687 0 0 1-.686-.735l.593-8.625Z"
    />
    <path stroke="#444" d="M10.125 5.5V3.062a2.062 2.062 0 0 0-4.125 0V5.5" />
  </svg>
);

export const guideDogsSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path
      stroke="#444"
      d="M11.84 11.04c0 2.475-1.68.75-3.75.75-2.071 0-3.75 1.753-3.75-.75a3.75 3.75 0 1 1 7.5 0ZM11.475 5.429a1.235 1.235 0 1 1-2.386-.64c.176-.658 1.013-1.646 1.672-1.47.66.177.89 1.45.714 2.11ZM4.825 5.396A1.172 1.172 0 0 0 7.09 4.79c-.168-.625-.962-1.562-1.588-1.395-.625.168-.844 1.377-.677 2.002ZM14.21 8.463a1.168 1.168 0 0 1-1.947-1.293c.357-.537 1.405-1.17 1.943-.813.537.357.36 1.568.004 2.106ZM1.97 8.463A1.168 1.168 0 1 0 3.917 7.17C3.56 6.633 2.512 6 1.974 6.357c-.537.357-.36 1.568-.004 2.106Z"
    />
  </svg>
);

export const babySvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path stroke="#444" d="M13.5 8.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z" />
    <path
      stroke="#444"
      d="M8 3c0-.167.1-.6.5-1s.833-.5 1-.5M7.5 3c0-.167-.1-1.1-.5-1.5-.4-.4-.833-.5-1-.5"
    />
    <path
      fill="#444"
      d="M7 8.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM10.5 8.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
    />
    <path
      stroke="#444"
      d="M6.5 10.5c.75 1 2.25 1 3 0M14.5 8c0 .578-.384 1.192-1 1.414V6.6c.207.084.397.217.557.387.287.302.443.684.443 1.014ZM1.5 8c0 .578.384 1.192 1 1.414V6.6a1.593 1.593 0 0 0-.557.387C1.657 7.288 1.5 7.67 1.5 8Z"
    />
  </svg>
);

export const lockSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <g stroke="#444">
      <path d="M11.889 7.278H4.11C3.497 7.278 3 7.775 3 8.388v3.89c0 .614.497 1.11 1.111 1.11h7.778c.614 0 1.111-.496 1.111-1.11v-3.89c0-.613-.498-1.11-1.111-1.11ZM5.2 7V4.778c0-.737.295-1.443.82-1.964A2.811 2.811 0 0 1 8 2c.743 0 1.455.293 1.98.814.525.52.82 1.227.82 1.964V7" />
    </g>
  </svg>
);

export const rampSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path
      fill="#444545"
      d="M5.539 4.377a1.385 1.385 0 1 1 .003.003l-.003-.003Zm.003-1.968a.585.585 0 1 0 0 1.168.585.585 0 0 0 0-1.168ZM6.94 12.733a3.4 3.4 0 0 1-2.086-.71 3.386 3.386 0 0 1-1.302-2.27 3.424 3.424 0 0 1 1.562-3.325.4.4 0 0 1 .426.678 2.588 2.588 0 0 0-.67.612 2.611 2.611 0 0 0-.524 1.936c.09.695.444 1.312.998 1.738a2.622 2.622 0 0 0 4.128-1.383.4.4 0 1 1 .774.212 3.417 3.417 0 0 1-3.302 2.512h-.003Z"
    />
    <path
      fill="#444545"
      d="M11.082 10.368 9.04 7.933a.067.067 0 0 0-.06-.023l-1.927.426a.719.719 0 0 1-.854-.544l-.596-2.688a.401.401 0 0 1 .304-.477.401.401 0 0 1 .477.304l.58 2.608 1.843-.41c.316-.07.64.042.848.289l1.568 1.868.62-.441a.397.397 0 0 1 .557.096.397.397 0 0 1-.096.557l-1.222.867v.003Z"
    />
    <path
      fill="#444545"
      d="M6.22 6.448a.403.403 0 0 1-.39-.314.401.401 0 0 1 .304-.476l2.093-.464a.401.401 0 0 1 .477.304.401.401 0 0 1-.304.476l-2.093.464a.397.397 0 0 1-.086.01ZM13.68 13.917H2.265a.436.436 0 0 1-.096-.86l11.51-2.555a.401.401 0 0 1 .478.304.401.401 0 0 1-.304.477l-8.256 1.83h8.083a.4.4 0 0 1 0 .8v.004Z"
    />
  </svg>
);

export const amenitiesIcons: Record<string, JSX.Element> = {
  'Seating Capacity': numberOfSeatsSvg,
  Restaurant: drinksSvg,
  Cafe: drinksSvg,
  'Dedicated Parking': parkingSvg,
  Elevators: elevatorSvg,
  Lift: elevatorSvg,
  'Wheelchair Accessible': wheelchairSvg,
  Cloakroom: cloakroomSvg,
  'Air Conditioning': airConditioningSvg,
  WiFi: wifiSvg,
  Bar: barSvg,
  'Water Fountain': waterDropSvg,
  Washrooms: washroomSvg,
  Toilets: washroomSvg,
  Binoculars: binocularSvg,
  'Adapted Toilets': accessibleToiletsSvg,
  'Accessible Toilets': accessibleToiletsSvg,
  'Assistive Listening System': hearingSvg,
  'Hearing Assistance': hearingSvg,
  'Booster Cushions': boosterCushionSvg,
  Shop: shopSvg,
  'Souvenir Shop': shopSvg,
  'Guide Dogs': guideDogsSvg,
  'Baby Changing Facilities': babySvg,
  'Security Check': lockSvg,
  Ramp: rampSvg,
  'Level Access': rampSvg,
};
